import { z } from 'my-zod'
import { attachmentModel } from '../attachment/attachment-model'
import {
  actionPlanTemplateModel,
  actionPlanTemplateTaskModel,
  actionPlanTemplateTaskGroupModel
} from './action-plan-templates-model'

export const actionPlanTemplateSystemView = actionPlanTemplateModel.augment({
  attachments: attachmentModel.array()
})
export type actionPlanTemplateSystemView = z.infer<typeof actionPlanTemplateSystemView>

export const actionPlanTemplateTaskSystemView = actionPlanTemplateTaskModel
export type actionPlanTemplateTaskSystemView = z.infer<typeof actionPlanTemplateTaskSystemView>

export const actionPlanTemplateTaskGroupSystemView = actionPlanTemplateTaskGroupModel
export type actionPlanTemplateTaskGroupSystemView = z.infer<typeof actionPlanTemplateTaskGroupSystemView>
